import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>Sorry,page not found</h1>
            <h4>404 err0r</h4>
        </div>
    );
};

export default Notfound